(function(){
	angular.module('cvsApp').directive('storeLocatorFooter',function(){
		return{
			restrict:'E',
			templateUrl: '../storelocator/app/components/storelocator-footer/storeLocatorFooter.html',
			controller: ['$scope',function($scope){
			}]	
		}
		
	})
})();